import io from 'socket.io-client';
import { SOCKETIOENDPOINTS } from './ApiEndPoints/SocketIOEndpoints';

const baseURL = ['development', 'staging', 'production'].includes(process.env.REACT_APP_ENV)
  ? `${window.location.origin}`
  : 'https://dev.esign-proteantech.in/';

export const getNotificationSocket = token =>
  io(`${baseURL}${SOCKETIOENDPOINTS.ENDPOINT.getNotification}`, {
    reconnectionDelay: 10000,
    path: '/socket.io',
    transports: ['polling'],
    extraHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
